import {
  GET_RECOLECCIONES_SOLICITADAS_START,
  GET_RECOLECCIONES_SOLICITADAS_SUCCESS,
  GET_RECOLECCIONES_SOLICITADAS_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: [],
  error: null
}

const solicitadas = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case GET_RECOLECCIONES_SOLICITADAS_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_RECOLECCIONES_SOLICITADAS_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case GET_RECOLECCIONES_SOLICITADAS_ERROR:
      return {
        ...state,
        loading: false,
        error
      }

    default: return state

  }

}

export default solicitadas